(() => {
  const galleries = document.querySelectorAll('[data-mf-detail-gallery]');

  galleries.forEach((gallery) => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';

    const viewport = gallery.querySelector('[data-gallery-viewport]');
    const track = gallery.querySelector('[data-gallery-track]');
    const countEl = gallery.querySelector('[data-gallery-count]');
    const controls = gallery.querySelector('[data-gallery-controls]');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    const progressBar = gallery.querySelector('[data-gallery-progress]');

    // Lightbox elements
    const lightbox = gallery.querySelector('[data-mf-lightbox]');
    const lightboxImg = gallery.querySelector('[data-lightbox-image]');
    const lightboxCounter = gallery.querySelector('[data-lightbox-counter]');
    const lightboxCloseBtns = gallery.querySelectorAll('[data-lightbox-close]');
    const lightboxPrev = gallery.querySelector('[data-lightbox-prev]');
    const lightboxNext = gallery.querySelector('[data-lightbox-next]');

    if (!viewport || !track) return;

    let activeLightboxIndex = 0;

    const getSlides = () => [...track.querySelectorAll('[data-gallery-slide]:not([hidden])')];

    const updateState = () => {
      const slides = getSlides();
      const total = slides.length;

      if (!total) {
        gallery.hidden = true;
        return;
      }

      if (controls) {
        controls.hidden = total < 2 || track.scrollWidth <= viewport.clientWidth + 2;
      }

      const scrollLeft = viewport.scrollLeft;
      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const viewCenter = scrollLeft + viewport.clientWidth / 2;
      let activeIndex = 1;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        if (slideCenter <= viewCenter + slide.offsetWidth * 0.4) {
          activeIndex = index + 1;
        }
      });

      if (countEl) {
        const currentStr = String(Math.min(activeIndex, total)).padStart(2, '0');
        const totalStr = String(total).padStart(2, '0');
        countEl.textContent = `${currentStr} / ${totalStr}`;
      }

      if (progressBar) {
        if (maxScroll <= 0) {
          progressBar.style.width = '100%';
        } else {
          const pct = Math.min(100, Math.max(0, (scrollLeft / maxScroll) * 100));
          progressBar.style.width = `${Math.max(pct, (1 / total) * 100)}%`;
        }
      }

      if (prevBtn) prevBtn.disabled = scrollLeft <= 5;
      if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 5;
    };

    // Remove broken images
    track.querySelectorAll('[data-gallery-image]').forEach((img) => {
      img.addEventListener('error', () => {
        const slide = img.closest('[data-gallery-slide]');
        if (slide) slide.hidden = true;
        updateState();
      });
    });

    // Page carousel arrows
    const scrollBySlide = (direction) => {
      const scrollDistance = Math.min(viewport.clientWidth * 0.75, 360);
      viewport.scrollBy({ left: direction * scrollDistance, behavior: 'smooth' });
    };

    prevBtn?.addEventListener('click', () => scrollBySlide(-1));
    nextBtn?.addEventListener('click', () => scrollBySlide(1));

    viewport.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState, { passive: true });
    window.addEventListener('load', updateState, { once: true });

    /* ==========================================================================
       Lightbox Controls & Desktop Arrows
       ========================================================================== */

    const openLightbox = (index) => {
      const slides = getSlides();
      if (!slides[index]) return;

      activeLightboxIndex = index;
      const targetSlide = slides[index];
      const imgSrc = targetSlide.dataset.fullSrc || targetSlide.querySelector('img')?.src;

      if (lightboxImg) {
        lightboxImg.src = imgSrc;
        lightboxImg.alt = targetSlide.querySelector('img')?.alt || 'Full size product detail image';
      }

      if (lightboxCounter) {
        lightboxCounter.textContent = `${String(activeLightboxIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      }

      lightbox?.classList.add('is-open');
      lightbox?.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      lightbox?.classList.remove('is-open');
      lightbox?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lightboxImg) lightboxImg.src = '';
    };

    const changeLightboxSlide = (direction) => {
      const slides = getSlides();
      if (!slides.length) return;
      activeLightboxIndex = (activeLightboxIndex + direction + slides.length) % slides.length;
      openLightbox(activeLightboxIndex);
    };

    // Open on slide click or keyboard space/enter
    track.addEventListener('click', (e) => {
      const slide = e.target.closest('[data-gallery-slide]');
      if (!slide) return;
      const index = getSlides().indexOf(slide);
      if (index !== -1) openLightbox(index);
    });

    track.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const slide = e.target.closest('[data-gallery-slide]');
        if (!slide) return;
        e.preventDefault();
        const index = getSlides().indexOf(slide);
        if (index !== -1) openLightbox(index);
      }
    });

    // Close on backdrop or close button
    lightboxCloseBtns.forEach((btn) => btn.addEventListener('click', closeLightbox));

    // Desktop Lightbox Next & Previous Arrow Click Handlers
    lightboxPrev?.addEventListener('click', (e) => {
      e.stopPropagation();
      changeLightboxSlide(-1);
    });

    lightboxNext?.addEventListener('click', (e) => {
      e.stopPropagation();
      changeLightboxSlide(1);
    });

    // Keyboard Arrow navigation (← / → / Esc)
    document.addEventListener('keydown', (e) => {
      if (!lightbox?.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') changeLightboxSlide(-1);
      if (e.key === 'ArrowRight') changeLightboxSlide(1);
    });

    // Touch Swipe in Modal on Mobile
    let touchStartX = 0;
    let touchEndX = 0;

    lightbox?.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox?.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchEndX - touchStartX;
      if (Math.abs(diff) > 45) {
        changeLightboxSlide(diff > 0 ? -1 : 1);
      }
    }, { passive: true });

    updateState();
  });
})();